interface IProps {
  label: string
  value: string
}

export const FormFieldLabel = ({ label, value }: IProps) => (
  <div className="arbitration-field">
    <span>{label}</span>
    <div>{value}</div>
  </div>
)
